<template lang="pug">
	footer.footer(v-if="!hideFooter")
		div
			.footer-link
				.columns.is-centered.is-vcentered
					.column.is-narrow
						.is-vcentered
							| {{ $t('footer.copyright') }}&nbsp;
							img.small-logo(src="/logo-kalilab.png" :alt="$t('alt.kalilab')" draggable="false")
					.column.is-hidden-mobile
					.column.is-narrow
						router-link(to="/terms") {{ $t('menu.terms') }}
						router-link(to="/warnings") {{ $t('menu.warnings') }}
						router-link(to="/privacy") {{ $t('menu.privacy') }}
			.footer-legal
				.columns.is-centered.is-vcentered.is-multiline.is-mobile
					.column.is-narrow
						span.no-wrap KALI LAB. Srl
					.column.is-narrow
						span.no-wrap Via Stupinigi n.29, 10048 Vinovo (TO)
					.column.is-narrow
						span.no-wrap {{ $t('footer.vat', { vat: '09663920016' }) }}
					.column.is-narrow
						span.no-wrap {{ $t('footer.pec', { mail: 'kalilabsrl@pec.it' }) }}
</template>

<script>
export default {
	data() {
		return {
			hideFooter: false
		}
	},
	mounted() {
		this.prepareRoute(this.$route, this.userState)
	},
	computed: {
		itClass() {
			return { 'is-active': this.$t('locale.lang') === 'it' }
		},
		enClass() {
			return { 'is-active': this.$t('locale.lang') === 'en' }
		},
		userState() {
			return this.$store.state.user.userState
		}
	},
	methods: {
		changeLanguageIt() {
			this.$root.$i18n.locale = 'it'
			this.$store.dispatch('general/setLocale', { locale: 'it' })
		},
		changeLanguageEn() {
			this.$root.$i18n.locale = 'en'
			this.$store.dispatch('general/setLocale', { locale: 'en' })
		},
		prepareRoute(to, userState) {
			if (to.meta.hideFooter) {
				this.hideFooter = true
			} else if (to.meta.hideFooterIfPayment) {
				if (userState && userState.has_subscription && (userState.trial_active || userState.subscription_active)) {
					this.hideFooter = false
				} else if (to.name === 'profile' && !userState) {
					this.hideFooter = true
				} else {
					this.hideFooter = true
				}
			} else {
				this.hideFooter = false
			}
		}
	},
	watch: {
		'$route' (to, from) {
			this.prepareRoute(to, this.userState)
		},
		userState (to, from) {
			this.prepareRoute(this.$route, to)
		}
  	}
}
</script>
